var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-12 px-4"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"px-2 text-center",attrs:{"cols":"12"}},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.$t("common:errorMessage.accessDenied.text", "Access denied"))+"\n      ")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t(
          "common:errorMessage.noPermission.text",
          "User does not have permission to access this page"
        )))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }